import store from '../store'
import langRU from "../plugins/langRU";
import langEN from "../plugins/langEN";

export default function langFilter(text){
  const lang = store.getters.info.lang || 'ru-RU';
  const locale = {
    'ru-RU': langRU,
    'en-US': langEN,
  }
  return locale[lang][text] || '[translation error]';
}
